export default __webpack_public_path__ + "static/media/help-4.e44ee1bf.png";